<template>
	<div>

		<el-row :gutter="5" style="margin-top: 10px;">
			<el-col>
				<!-- <el-card> -->
					<el-tabs v-model="activeName" @tab-click="handleClick" tab-position="top">
						<el-tab-pane name="first">
							<span slot="label">
								<i class="el-icon-s-shop"></i>
								产品使用
							</span>
							<el-col>
								<transition name="el-fade-in-linear"><router-view :key="$route.fullPath" name="a" v-if="isRouterAlive" /></transition>
							</el-col>
						</el-tab-pane>
						<el-tab-pane name="second">
							<span slot="label">
								<i class="el-icon-s-tools"></i>
								科室设备及运转
							</span>
							<el-col>
								<transition name="el-fade-in-linear"><router-view :key="$route.fullPath" name="b" v-if="isRouterAlive" /></transition>
							</el-col>
						</el-tab-pane>
						<el-tab-pane name="third">
							<span slot="label">
								<i class="el-icon-s-custom"></i>
								重要联系人
							</span>
							<el-col>
								<transition name="el-fade-in-linear"><router-view :key="$route.fullPath" name="c" v-if="isRouterAlive" /></transition>
							</el-col>
						</el-tab-pane>
						<el-tab-pane name="fourth">
							<span slot="label">
								<i class="el-icon-s-shop"></i>
								供货方式
							</span>
							<el-col>
								<transition name="el-fade-in-linear"><router-view :key="$route.fullPath" name="d" v-if="isRouterAlive" /></transition>
							</el-col>
						</el-tab-pane>
						<el-tab-pane name="fifth">
							<span slot="label">
								<i class="el-icon-s-order"></i>
								招投标
							</span>
							<el-col>
								<transition name="el-fade-in-linear"><router-view :key="$route.fullPath" name="f" v-if="isRouterAlive" /></transition>
							</el-col>
						</el-tab-pane>
					</el-tabs>
				<!-- </el-card> -->
			</el-col>
		</el-row>
	</div>
</template>
<script>
export default {
	data() {
		return {
			activeName: 'first',
			isRouterAlive: true
		};
	},
	mounted() {
	},
	methods: {
		handleClick(tab, event) {
			// console.log(tab, event);
		}
	}
};
</script>

<style>
</style>
